export { WixDesignSystemProvider } from './WixDesignSystemProvider';
export * from './WixDesignSystemProvider.types';
